import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import LoadingPage from "../../../Components/layouts/loading";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from "chart.js";
import "chartjs-adapter-date-fns";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import { FcPieChart } from "react-icons/fc";
import StepRoutes from "../../../Routes/steps_routes";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

function formatSecondsToHMS(seconds) {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  const pad = (n) => n.toString().padStart(2, "0");
  return `${pad(hrs)}h : ${pad(mins)}m : ${pad(secs)}s`;
}
const View_analytics = () => {
  const [data, setData] = useState();
  let { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [chartDataAttemptedCalls, setChartDataAttemptedCalls] = useState({
    labels: [],
    datasets: [],
  });
  const [chartDataConnectedCalls, setChartDataConnectedCalls] = useState({
    labels: [],
    datasets: [],
  });

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/salesPerformance/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    if (!data) return;

    const labels = [
      "09 to 10",
      "10 to 11",
      "11 to 12",
      "12 to 01",
      "01 to 02",
      "02 to 03",
      "03 to 04",
      "04 to 05",
      "05 to 06",
    ];

    const attemptedCallsData = [
      data?.attemptedCalls09to10 ?? 0,
      data?.attemptedCalls10to11 ?? 0,
      data?.attemptedCalls11to12 ?? 0,
      data?.attemptedCalls12to01 ?? 0,
      data?.attemptedCalls01to02 ?? 0,
      data?.attemptedCalls02to03 ?? 0,
      data?.attemptedCalls03to04 ?? 0,
      data?.attemptedCalls04to05 ?? 0,
      data?.attemptedCalls05to06 ?? 0,
    ];

    setChartDataAttemptedCalls({
      labels,
      datasets: [
        {
          label: "Attempted Calls",
          data: attemptedCallsData,
          backgroundColor: "rgba(153, 102, 255, 0.5)",
          borderColor: "rgba(153, 102, 255, 1)",
          borderWidth: 1,
          tension: 0.5,
        },
      ],
    });
  }, [data]);
  useEffect(() => {
    if (!data) return;

    const labels = [
      "09 to 10",
      "10 to 11",
      "11 to 12",
      "12 to 01",
      "01 to 02",
      "02 to 03",
      "03 to 04",
      "04 to 05",
      "05 to 06",
    ];

    const connectedCallsData = [
      data?.connectedCalls09to10 ?? 0,
      data?.connectedCalls10to11 ?? 0,
      data?.connectedCalls11to12 ?? 0,
      data?.connectedCalls12to01 ?? 0,
      data?.connectedCalls01to02 ?? 0,
      data?.connectedCalls02to03 ?? 0,
      data?.connectedCalls03to04 ?? 0,
      data?.connectedCalls04to05 ?? 0,
      data?.connectedCalls05to06 ?? 0,
    ];

    setChartDataConnectedCalls({
      labels,
      datasets: [
        {
          label: "Connected Calls",
          data: connectedCallsData,
          backgroundColor: "rgba(153, 102, 255, 0.5)",
          borderColor: "rgba(153, 102, 255, 1)",
          borderWidth: 1,
          tension: 0.5,
        },
      ],
    });
  }, [data]);
  const options = {
    responsive: true,

    plugins: {
      tooltip: {
        enabled: true,
      },

      legend: {
        display: true,
        position: "top",
      },
    },

    layout: {
      padding: {
        top: 10,
        left: 10,
        right: 10,
        bottom: 10,
      },
    },

    scales: {
      x: {
        stacked: true,

        grid: {
          display: true,
          color: "rgba(200, 200, 200, 0.6)",
        },

        ticks: {
          padding: 10,
          color: "#000",
        },

        title: {
          display: true,
          text: "Time Slots",
        },
      },

      y: {
        beginAtZero: true,

        grid: {
          display: true,
          color: "rgba(200, 200, 200, 0.6)",
        },

        ticks: {
          padding: 10,
          color: "#000",
        },

        title: {
          display: true,
          text: "Calls Count",
        },
      },
    },

    animation: {
      duration: 1200,
      easing: "easeOutQuart",
    },
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcPieChart className="fs-2  me-1" /> Performance analytics
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header row g-2 align-items-center">
              <div className="col">
                <h2>View Record - {data?.date}</h2>
              </div>
              <div className="col-auto ms-auto d-print-none"></div>
            </div>
            <div className="card-body">
              <div
                className="p-4 rounded shadow-sm mb-4"
                style={{ background: "#fff" }}
              >
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h3 className="mb-0">Employee Details</h3>
                </div>

                <hr />

                <div className="row g-3">
                  {/* Sales Person Name */}
                  <div className="col-12 col-md-6">
                    <div className="border rounded p-3 h-100">
                      <label className="form-label text-muted fw-semibold">
                        Sales Person Name
                      </label>

                      <div className="fs-5 fw-bold">
                        {data?.salesPersonName ?? "N/A"}
                      </div>
                    </div>
                  </div>

                  {/* Sales Person Id */}
                  <div className="col-12 col-md-6">
                    <div className="border rounded p-3 h-100">
                      <label className="form-label text-muted fw-semibold">
                        Sales Person ID
                      </label>

                      <div className="fs-5 fw-bold">
                        {data?.salsePersonId ?? "N/A"}
                      </div>
                    </div>
                  </div>

                  {/* Mobile Number */}
                  <div className="col-12 col-md-6">
                    <div className="border rounded p-3 h-100">
                      <label className="form-label text-muted fw-semibold">
                        Allotted Mobile Number
                      </label>

                      <div className="fs-5 fw-bold">
                        {data?.allottedMobileNumber ?? "N/A"}
                      </div>
                    </div>
                  </div>

                  {/* Whatsapp Number */}
                  <div className="col-12 col-md-6">
                    <div className="border rounded p-3 h-100">
                      <label className="form-label text-muted fw-semibold">
                        Allotted Whatsapp Number
                      </label>

                      <div className="fs-5 fw-bold">
                        {data?.allottedWhatsappNumber ?? "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="border rounded p-3 h-100">
                      <label className="form-label text-muted fw-semibold">
                        Sales Team
                      </label>

                      <div className="fs-5 fw-bold">
                        {data?.salesTeam ?? "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr />
              <div className="row g-4">
                {/* ================= RECORDS TILL DATE ================= */}
                <div className="col-12 col-xl-6">
                  <div
                    className="p-4 rounded-4 shadow-sm border-0 h-100"
                    style={{
                      background: "#ffffff",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h3 className="mb-0 fw-bold">Records Till Date</h3>

                      <div className="badge bg-primary-subtle text-primary px-3 py-2">
                        Lifetime
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls Made Till Date
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsMadeTillDate ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls Connected Till Date
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsConnectedTillDate ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls Via Whatsapp
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsMadeViaWhatsappTillDate ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls Via Network
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsMadeViaNetworkTillDate ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Unique Leads Called
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.uniqueLeadsCalledTillDate ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls Duration
                      </label>

                      <div className="fw-bold fs-6 text-end">
                        {formatSecondsToHMS(data?.callsDurationTillDate) ??
                          "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center pt-3">
                      <label className="fw-semibold text-secondary">
                        Incoming / Outgoing Ratio
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.incomingOutgoingCallRatioTillDate ?? "N/A"}
                      </div>
                    </div>
                  </div>
                </div>

                {/* ================= TODAY DETAILS ================= */}
                <div className="col-12 col-xl-6">
                  <div
                    className="p-4 rounded-4 shadow-sm border-0 h-100"
                    style={{
                      background: "#ffffff",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h3 className="mb-0 fw-bold">Today's Details</h3>

                      <div className="badge bg-success-subtle text-success px-3 py-2">
                        Today
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">Date</label>

                      <div className="fw-bold fs-6 text-end">
                        {data?.date ?? "N/A"}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls Duration Day
                      </label>

                      <div className="fw-bold fs-6 text-end">
                        {formatSecondsToHMS(data?.callsDurationDay) ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Incoming / Outgoing Ratio
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.incomingOutgoingCallRatioDay ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        First Call Time
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.firstCallTimeOfDayDay ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Last Call Time
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.lastCallTimeOfDayDay ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Leads Assigned
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.totalLeadsAssignedPerDay ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center pt-3">
                      <label className="fw-semibold text-secondary">
                        Pending Leads
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.pendingAssignedLeadsPerDay ?? "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <h3 className="mb-4">Today's Attempted Calls</h3>
              <div className="row g-4">
                {/* LEFT SIDE - DATA */}
                <div className="col-12 col-lg-5">
                  <div
                    className="p-3 rounded shadow-sm h-100"
                    style={{ background: "#fff" }}
                  >
                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Attempted Calls 09 to 10
                      </label>
                      <div className="col-4 text-end">
                        {data?.attemptedCalls09to10 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Attempted Calls 10 to 11
                      </label>
                      <div className="col-4 text-end">
                        {data?.attemptedCalls10to11 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Attempted Calls 11 to 12
                      </label>
                      <div className="col-4 text-end">
                        {data?.attemptedCalls11to12 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Attempted Calls 12 to 01
                      </label>
                      <div className="col-4 text-end">
                        {data?.attemptedCalls12to01 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Attempted Calls 01 to 02
                      </label>
                      <div className="col-4 text-end">
                        {data?.attemptedCalls01to02 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Attempted Calls 02 to 03
                      </label>
                      <div className="col-4 text-end">
                        {data?.attemptedCalls02to03 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Attempted Calls 03 to 04
                      </label>
                      <div className="col-4 text-end">
                        {data?.attemptedCalls03to04 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Attempted Calls 04 to 05
                      </label>
                      <div className="col-4 text-end">
                        {data?.attemptedCalls04to05 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-0">
                      <label className="col-8 fw-semibold">
                        Attempted Calls 05 to 06
                      </label>
                      <div className="col-4 text-end">
                        {data?.attemptedCalls05to06 ?? "N/A"}
                      </div>
                    </div>
                  </div>
                </div>

                {/* RIGHT SIDE - CHART */}
                <div className="col-12 col-lg-7">
                  <div
                    className="p-3 rounded shadow-sm h-100"
                    style={{ background: "#fff", minHeight: "400px" }}
                  >
                    <Line data={chartDataAttemptedCalls} options={options} />
                  </div>
                </div>
              </div>
              <hr />
              <h3 className="mb-4">Today's Connected Calls</h3>
              <div className="row g-4">
                {/* LEFT SIDE - DATA */}
                <div className="col-12 col-lg-5">
                  <div
                    className="p-3 rounded shadow-sm h-100"
                    style={{ background: "#fff" }}
                  >
                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Connected Calls 09 to 10
                      </label>
                      <div className="col-4 text-end">
                        {data?.connectedCalls09to10 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Connected Calls 10 to 11
                      </label>
                      <div className="col-4 text-end">
                        {data?.connectedCalls10to11 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Connected Calls 11 to 12
                      </label>
                      <div className="col-4 text-end">
                        {data?.connectedCalls11to12 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Connected Calls 12 to 01
                      </label>
                      <div className="col-4 text-end">
                        {data?.connectedCalls12to01 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Connected Calls 01 to 02
                      </label>
                      <div className="col-4 text-end">
                        {data?.connectedCalls01to02 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Connected Calls 02 to 03
                      </label>
                      <div className="col-4 text-end">
                        {data?.connectedCalls02to03 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Connected Calls 03 to 04
                      </label>
                      <div className="col-4 text-end">
                        {data?.connectedCalls03to04 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-8 fw-semibold">
                        Connected Calls 04 to 05
                      </label>
                      <div className="col-4 text-end">
                        {data?.connectedCalls04to05 ?? "N/A"}
                      </div>
                    </div>

                    <div className="row mb-0">
                      <label className="col-8 fw-semibold">
                        Connected Calls 05 to 06
                      </label>
                      <div className="col-4 text-end">
                        {data?.connectedCalls05to06 ?? "N/A"}
                      </div>
                    </div>
                  </div>
                </div>

                {/* RIGHT SIDE - CHART */}
                <div className="col-12 col-lg-7">
                  <div
                    className="p-3 rounded shadow-sm h-100"
                    style={{ background: "#fff", minHeight: "400px" }}
                  >
                    <Line data={chartDataConnectedCalls} options={options} />
                  </div>
                </div>
              </div>
              <hr />
              <div className="row g-4">
                {/* ================= WEEKLY CALL DETAILS ================= */}
                <div className="col-12 col-xl-6">
                  <div
                    className="p-4 rounded-4 shadow-sm border-0 h-100"
                    style={{
                      background: "#ffffff",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h3 className="mb-0 fw-bold">Weekly Call Details</h3>

                      <div className="badge bg-primary-subtle text-primary px-3 py-2">
                        This Week
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls Made This Week
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsMadeThisWeek ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls Connected
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsConnectedWeek ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls Via Whatsapp
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsMadeViaWhatsappWeek ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls Via Network
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsMadeViaNetworkWeek ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls Duration
                      </label>

                      <div className="fw-bold fs-6 text-end">
                        {formatSecondsToHMS(data?.callsDurationWeek) ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Incoming / Outgoing Ratio
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.incomingOutgoingCallRatioWeek ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls To Masterclass
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsToMasterclassRatioWeek ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls To Training
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsToPracticalTrainingRatioWeek ?? "N/A"}
                      </div>
                    </div>

                    {/* <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls To Office Visit
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsToOfficeVisitRatioWeek ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls To Quotation
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsToQuotationRatioWeek ?? "N/A"}
                      </div>
                    </div> */}

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls To Site Inspection
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsToSiteInspectionRatioWeek ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Calls To Conversion
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.callsToConversionRatioWeek ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Very Short Calls
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.veryShortCallsCountWeek ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center pt-3">
                      <label className="fw-semibold text-secondary">
                        Very Long Calls
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.veryLongCallsCountWeek ?? "N/A"}
                      </div>
                    </div>
                  </div>
                </div>

                {/* ================= WEEKLY SALES DETAILS ================= */}
                <div className="col-12 col-xl-6">
                  <div
                    className="p-4 rounded-4 shadow-sm border-0 h-100"
                    style={{
                      background: "#ffffff",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h3 className="mb-0 fw-bold">Weekly Sales Details</h3>

                      <div className="badge bg-success-subtle text-success px-3 py-2">
                        Revenue
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Masterclass Sales
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.salesMasterclassCountWeek ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Training Sales
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.salesTrainingCountWeek ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Homekit Sales
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.salesHomekitCountWeek ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Site Inspection Sales
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.salesSiteInspectionCountWeek ?? "N/A"}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Site Inspections Done
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.siteInspectionsDoneWeek ?? "N/A"}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Projects Closed
                      </label>

                      <div className="fw-bold fs-5">
                        {data?.projectsClosedCountWeek ?? "N/A"}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Masterclass Revenue
                      </label>

                      <div className="fw-bold fs-5 text-success">
                        {roundOffCost(data?.revenueMasterclassWeek) ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Training Revenue
                      </label>

                      <div className="fw-bold fs-5 text-success">
                        {roundOffCost(data?.revenueTrainingWeek) ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Homekit Revenue
                      </label>

                      <div className="fw-bold fs-5 text-success">
                        {roundOffCost(data?.revenueHomekitWeek) ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Site Inspection Revenue
                      </label>

                      <div className="fw-bold fs-5 text-success">
                        {roundOffCost(data?.revenueSiteInspectionWeek) ?? "N/A"}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
                      <label className="fw-semibold text-secondary">
                        Total Revenue Closed
                      </label>

                      <div className="fw-bold fs-5 text-success">
                        {roundOffCost(data?.totalRevenueClosedWeek) ?? "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* {data &&
                Object.entries(data)?.map((el, index) => {
                  return (
                    <div className="mb-3 row" key={index}>
                      <label className="w-25 form-label col-3">
                        {el?.[0] ? formatText(el[0]) : ""}
                      </label>
                      <div className="w-100 col">
                        {el?.[1]
                          ? el[0].toLowerCase().includes("duration")
                            ? formatSecondsToHMS(el[1])
                            : el[0].toLowerCase().includes("revenue")
                            ? roundOffCost(el?.[1])
                            : el[1]
                          : "N/A"}
                      </div>{" "}
                    </div>
                  );
                })} */}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton buttonText="Back" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default View_analytics;
